import React, { Component, Fragment } from 'react'

import polishMap from '../../maps/map_pl.svg';
import englishMap from '../../maps/map_en.svg';

import $ from 'jquery';

import { CountUp } from 'countup.js'

const regex = /(<([^>]+)>)/ig;

class VCCustomWSGroupMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fullWidthStyle: null,
    }
    this.containerNode = React.createRef()
  }
  img;
  handleResize = () => {
    const { clientWidth } = this.containerNode.current;
    const space = (window.innerWidth - clientWidth) / 2;
    const lang = window.location.pathname.split('/')[1];
    if (lang === 'pl') {
      this.img = polishMap
    }else{
      this.img = englishMap
    };
    const fullWidthStyle = {
      marginLeft: '-' + space + 'px',
      paddingLeft: space + 'px',
      marginRight: '-' + space + 'px',
      paddingRight: space + 'px',
      background: `url(${this.img}) no-repeat 100% 0` 
    }
    this.setState({ fullWidthStyle })
  }

  componentDidMount() {
    this.handleResize();
    this.checkScrollPosition();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  
  checkScrollPosition() {    
    const that = this;
    $(window).scroll(function () {   
        if ($('.wsgroup-map').length > 0) {
           var containerToAnimatePositionTop = $('.wsgroup-map').offset().top;
           if ( $(window).scrollTop() >= containerToAnimatePositionTop - 400 ) {        
              that.configureNumberAnimation();
              $(window).off('scroll');
           } 
        }
    })
  }

  configureNumberAnimation() {
    const options = {
      separator: ' ',
      startVal: 0
    };
    let items = null;
    if(typeof this.props.csv !== 'undefined') {
        items = this.props.csv.replace(/\r\n/g, '\n').split('\n');
    }
    if(items !== null) {
        items.forEach((item, i) => {
          const numberToUp = +item.split(',')[0].split(' ').join('');
          new CountUp(`${i + 1}`, numberToUp, options).start();
        });
    }
  }

  render() {
    let items = null;
    if(typeof this.props.csv !== 'undefined') {
        items = this.props.csv.replace(/\r\n/g, '\n').split('\n'); 
    }
    return (
      <Fragment>
        <div className='wsgroup-map-column-size' ref={this.containerNode}>
          &nbsp;
        </div>
        <div  className='wsgroup-map' style={this.state.fullWidthStyle}>
          {items !== null &&
          <ul>
              <li>
                <span id="1">{ items[0].split(',')[0].replace(regex, '') }</span> {items[0].split(',')[1].replace(regex, '')}{items[0].split(',')[2] ? <Fragment><br />{items[0].split(',')[2].replace(regex, '')}</Fragment> : null}
              </li>
              <li>
                <span id="2">{ items[1].split(',')[0].replace(regex, '') }</span> {items[1].split(',')[1].replace(regex, '')}{items[1].split(',')[2] ? <Fragment><br />{items[1].split(',')[2].replace(regex, '')}</Fragment> : null}
              </li>
              <li>
                <span id="3">{items[2].split(',')[0].replace(regex, '') }</span> {items[2].split(',')[1].replace(regex, '')}{items[2].split(',')[2] ? <Fragment><br />{items[2].split(',')[2].replace(regex, '')}</Fragment> : null}
              </li>
          </ul>
          }
          <h4>{this.props.title}</h4>
        </div>
      </Fragment>
    )
  }
}

export default VCCustomWSGroupMap




// WEBPACK FOOTER //
// ./src/custom/components/VCCustomWSGroupMap.js